import { State, Draft, Payload } from '@smile-next/uikit';
import { SSOParams } from '@/models/domain/SSOParams';
import { LoadedSSOParamsPayload } from '@/usecases/LoadSSOParamsUseCase';
import { AuthenticatedFailurePayload } from '@/usecases/payload/AuthenticatedFailurePayload';

export class SSOCallbackPageState extends State {
    constructor(
        // prettier-ignore
        public readonly ssoParams?: SSOParams,
        public readonly errorMessage?: string,
    ) {
        super();
    }

    reduce(this: Draft<this>, payload: Payload) {
        if (payload instanceof LoadedSSOParamsPayload) {
            this.ssoParams = payload.ssoParams;
        }

        if (payload instanceof AuthenticatedFailurePayload) {
            this.errorMessage = payload.authenticatedFailurePayloadArgs.error.message;
        }
    }
}
